export function getTimeZone(market) {
  if (market === 'us') {
    return '美东'
  } else if (market === 'jp') {
    return '东京'
  } else {
    return '北京'
  }
}

export function getMarket(symbol) {
  if (symbol) {
    const suffix = symbol.split('.').pop().toLowerCase()
    if (['hk', 'us', 'jp'].includes(suffix)) {
      return suffix
    } else if (['sh', 'sz'].includes(suffix)) {
      return 'hs'
    } else {
      return 'us'
    }
  } else {
    console.error('没有symbol参数')
  }
}
